import { useCallback, useMemo } from "react";
import { useEmployeeTeams } from "./use-employee-teams";

export function useTeamDisplayNames() {
  const { data: teams } = useEmployeeTeams();

  const teamDisplayNames = useMemo(() => {
    if (!teams) return new Map<string, string>();
    return new Map(teams.map((team) => [team.id, team.display_name]));
  }, [teams]);

  const getTeamDisplayName = useCallback(
    (teamId: string) => {
      return teamDisplayNames.get(teamId) || teamId;
    },
    [teamDisplayNames],
  );

  return {
    teamDisplayNames,
    getTeamDisplayName,
    isLoading: !teams,
  };
}
